<template>
    <div class="constrain">
        <div v-if="errorMessage">{{ this.errorMessage }}</div>
        <div :id="id"></div>
    </div>
</template>
<script>
    let dropin = require('braintree-web-drop-in');
    export default {
        props: {
            token: { default : '' }
        },
        data: function() {
            return {
                id: this.$root.uniqueid(),
                clientToken: this.token,
                errorMessage: '',
                dropinInstance: '',
                dropinPayload: '',
                model: {}
            }
        },
        created() {
            this.dropinUI();
        },
        methods: {
            dropinUI() {
                dropin.create({
                    authorization: this.clientToken,
                    paypal: {
                        flow: 'vault'
                    },
                    selector: '#' + this.id
                }, (dropinErr, dropinInstance) => {
                    if (dropinErr) {
                        this.errorMessage = 'There was an error setting up the Drop-in! Message: ' + dropinErr.message;
                        return;
                    }
                    this.dropinInstance = dropinInstance;
                    this.$emit('input', this.dropinInstance);
                })
            },
        }
    }
</script>
<style>
  /*  .braintree-method .braintree-method__label {
        color: #ccc;
    }

    .braintree-heading {
        display: none;
    }

    .braintree-method.braintree-method--active {
        background: transparent;
        border: none;
        box-shadow: none;
        padding: 0;
    }

    .braintree-toggle {
        padding: 0;
        background: transparent;
        color: #fff;
        text-align: left;
    }

    .braintree-toggle span {
        border: none;
    }*/
</style>
